// opens modals associated with button when users click it before foundation is fully loaded
// button is replaced with a loading svg until foundation properly loads
(() => {
  // any clicked button that has data-open but not the aria-controls attribute is not fully loaded
  document.addEventListener("click", function (event) {
    // Check if the clicked element or any of its parents is a button with 
    // an associated modal and no aria-controls attr
    let target = event.target.closest("button[data-open]");
    if(!target)
      return;
    let modalAssociated = document.getElementById(`${target.getAttribute("aria-controls")}`);

    // if the target is present but there's no modal associated, it's not loaded
    if (target && !modalAssociated) {
      // Show loading indicator until modal is ready
      const loadingHtml = `
            <div class="loading-image-button">
            </div>`;
      target.style.display = "none";
      target.insertAdjacentHTML("beforebegin", loadingHtml);
      // attach a mutation observer to detect changes on this element
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // When aria-controls is added, remove loading indicator and show the button
          const button = mutation.target;
          const loadingImg = button.parentElement.querySelector(".loading-image-button");
          const modalID = button.getAttribute("data-open");

          loadingImg.remove();
          button.style.display = "";

          // init and open modal
          var modal = new Foundation.Reveal($(`#${modalID}`));
          modal.open();

          observer.disconnect();
        });
      });
      // Configure and start observing the button for attribute changes
      observer.observe(target, {
        attributes: true,
        attributeFilter: ["aria-controls"],
      });
    }
  });
})();
